'use strict';
import { Howl } from 'howler';

class BGMController extends Howl {
  constructor(path, html5) {
    super({
      src: [path],
      preload: true,
      html5: html5,
      sprite: {
        proc_field01: [0, 27167.34693877551],
      },
    });

    this.spriteKeys = ['proc_field01'];
  }

  hasKey(key) {
    return this.spriteKeys.includes(key);
  }
}

export default BGMController;
